// extracted by mini-css-extract-plugin
export var divider = "_z3-0";